import { useRecoilState, useRecoilValue } from 'recoil';
import { FLEET_ASSETS_PAGE } from '../../constants/fleet';
import { useSidenavItems } from '../../hooks/useSidenavItems';
import { canAccessMyFleetState, pagesState, sidenavSectionsState } from '../../storage/app';
import SidenavWrapper from '../shared/SidenavWrapper';

export function Sidenav() {
  const pages = useRecoilValue(pagesState);
  const [expanded, setExpanded] = useRecoilState(sidenavSectionsState);
  const canAccessMyFleet = useRecoilValue(canAccessMyFleetState);

  return (
    <SidenavWrapper
      pages={pages}
      useSidenavItems={useSidenavItems}
      expanded={expanded}
      setExpanded={setExpanded}
      redirectPage={canAccessMyFleet ? FLEET_ASSETS_PAGE : undefined}
    />
  );
}
